/* eslint-disable */

import axios from "axios";
import { make } from "vuex-pathify";
import { tz } from "../../../utils/timezone";
import moment from "moment";
import momentTz from "moment-timezone";

const url = require("../../client_config/config").url;

const state = {
  allServices: [],
  adls: [],
  services: [],
  service: {},
  allCientServices: [],
  dialog: null,
  isSaving: false,
  isLoading: false,
  isSelectedMultipleItem: false,
  isDisableButton: true,
  confirmedDialog: false,
};

const getters = {
  getADLs: (state) => state.adls,
  getAllClientServices: (state) => {
    return state.allCientServices.map((item) => {
      return {
        ...item,
        newTime: moment(item.ScheduledTime, ["h:mm A"]).format("H"),
        newItem: item.ServiceItem,
      };
    });
  },
};

const actions = {
  // Get all servicecs schedule time
  async getAllServices({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/servicePlans/${id}/time`);
      commit("SET_ALL_SERVICES", response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
      return error;
    }
  },

  async fetchAllClientServices({ commit }, id) {
    let tz = momentTz.tz.guess();
    try {
      const response = await axios.get(`${url}/servicePlans/all/serv/${id}`, {
        params: { tz },
      });
      commit("SET_ALL_CLIENT_SERVICES", response.data.services);
    } catch (error) {
      console.log(error);
      return error;
    }
  },

  async getAllClientsServs({ commit }, data) {
    console.log(data)
    let tz = momentTz.tz.guess();
    try {
      const response = await axios.get(`${url}/servicePlans/all/clients/serv`, {
        params: { tz, clientIds: data },
      });
      console.log(response)
      return response.data;
    } catch (error) {
      console.log(error);
      return error;
    }
  },

  async fetchADL({ commit }, data) {
    try {
      const response = await axios.get(`${url}/adl/client/${data.id}`);
      const itemData = response.data.adl.map((item) => {
        return {
          ...item,
          ServiceName: `${item.Service?.Type} - ${item.Service?.ServiceItem}`,
          Date: tz(item.Date, data.userTimezone).format("YYYY-MM-DD"),
        };
      });
      commit("SET_ADLS", itemData);
      return response;
    } catch (error) {
      console.error(error);
      return error;
    }
  },

  async getSpecificService({ commit }, { id, clientId, time }) {
    try {
      const response = await axios.get(
        `${url}/servicePlans/specific/${id}/${clientId}/${time}`
      );
      commit("SET_SPECIFIC_SERVICE", response.data);
      return response;
    } catch (error) {
      console.error(error.response);
      return error.response;
    }
  },

  async getAdls({ commit }, { id, userTimezone }) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/adl/client/${id}`);
      commit("SET_ADLS", {
        data: response.data.adls,
        userTimezone: userTimezone,
      });
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
      return error;
    }
  },

  async addMultipleADL({ commit }, data) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.post(`${url}/ADL/multiple/`, data);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "ADL successfully added",
          color: "deep-purple accent-4",
        },
        null,
        { root: true }
      );
      commit("SET_LOADING", false);
      return response;
    } catch (error) {
      return error;
    }
  },

  async addADL({ commit }, data) {
    // commit("SET_LOADING", true);
    try {
      const response = await axios.post(`${url}/adl`, data);
      commit(
        "SET_SNACKBAR",
        {
          show: true,
          text: "ADL successfully added",
          color: "deep-purple accent-4",
        },
        null,
        { root: true }
      );
      // commit("SET_LOADING", false);
      return response;
    } catch (error) {
      return error.response;
    }
  },
};

const mutations = {
  ...make.mutations(state),

  // SET_ADLS(state, adl) {
  //   state.adls = [];
  //   adl.data.map((item) => {
  //     item.Date = tz(item.Date, adl.userTimezone).format("MM-DD-YYYY");
  //     item.ServiceName = `${item.Service.Type} - ${item.Service.ServiceItem}`;
  //     state.adls.push(item);
  //   });
  // },

  SET_SPECIFIC_SERVICE(state, data) {
    state.service = data;
  },

  SET_ALL_SERVICES(state, data) {
    state.services = data;
  },

  SET_ALL_CLIENT_SERVICES(state, data) {
    state.allCientServices = data;
  },

  SET_ADLS(state, data) {
    state.adls = data;
  },

  ADD_ADL(state, data) {
    state.adls = data;
  },

  SET_DIALOG(state, data) {
    state.dialog = data;
  },

  SET_IS_SAVING(state, data) {
    state.isSaving = data;
  },

  SET_DISABLE_BUTTON(state, data) {
    state.isDisableButton = data;
  },

  SET_LOADING(state, data) {
    state.isLoading = data;
  },

  SET_IS_SELECTED_MULTIPLE_ITEM(state, data) {
    state.isSelectedMultipleItem = data;
  },

  SET_CONFIRMED_DIALOG(state, data) {
    state.confirmedDialog = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
